import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tumblr",
  "use": "icon-tumblr-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 20 20\" id=\"icon-tumblr\"><path d=\"M4.373 8.639h1.889v6.398q0 1.158.259 1.904.289.686.899 1.219.594.548 1.569.899.929.32 2.117.32 1.036 0 1.935-.229.777-.152 2.026-.746V15.54q-1.264.868-2.62.868-.67 0-1.341-.35-.396-.259-.594-.716-.152-.503-.152-2.026V8.639h4.113V5.775H10.36V1.19H7.892q-.122 1.295-.594 2.3-.472.975-1.188 1.554-.746.701-1.737 1.005v2.59z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol